/* eslint-disable no-unused-vars */
import { ReactNode } from "react";
import AccordionStoryBook from "legacy/stories/Accordion";

interface AccordionProps {
  title: string | ReactNode;
  open?: boolean;
  hasResult?: boolean;
  className?: ((isOpen?: boolean) => string) | string;
  titleClassName?: ((isOpen?: boolean) => string) | string;
  contentClassName?: ((isOpen?: boolean) => string) | string;
  openAccordion?: (isOpen: boolean) => void;
  iconComponent?: (isOpen?: boolean) => ReactNode;
  titleIsHtml?: boolean;
  isLocked?: boolean;
  lockClickHandler?: () => void;
  children?: ReactNode;
}

const Accordion: React.FC<AccordionProps> = ({ children, ...props }) => {
  return <AccordionStoryBook {...props}>{children}</AccordionStoryBook>;
};

export default Accordion;
